import { msg } from '@lingui/core/macro';

export const SERIES_COLOR_PALETTE = [
  'var(--vis-azure-50)',
  'var(--vis-yellow-50)',
  'var(--vis-mint-50)',
  'var(--vis-salmon-50)',
  'var(--vis-slateblue-50)',
  'var(--vis-olive-50)',
  'var(--vis-pink-50)',
  'var(--vis-turquoise-50)',
  'var(--vis-orange-50)',
  'var(--vis-blue-50)',
];

export enum CONVERSATION_RATING {
  AMAZING = '🤩 Amazing',
  GREAT = '😃 Great',
  OK = '😐 Ok',
  BAD = '🙁 Bad',
  TERRIBLE = '😠 Terrible',
  UNKNOWN = 'Unknown',
}

export const CONVERSATION_RATINGS_COLORS = {
  [CONVERSATION_RATING.AMAZING]: 'var(--vis-green-40)',
  [CONVERSATION_RATING.GREAT]: 'var(--vis-green-60)',
  [CONVERSATION_RATING.OK]: 'var(--vis-yellow-70)',
  [CONVERSATION_RATING.BAD]: 'var(--vis-yellow-50)',
  [CONVERSATION_RATING.TERRIBLE]: 'var(--vis-salmon-40)',
  [CONVERSATION_RATING.UNKNOWN]: 'var(--neutral-border-emphasis)',
};

export enum CONVERSATION_STATES {
  OPENED = 'Open',
  SNOOZED = 'Snoozed',
  CLOSED = 'Closed',
}

export const CONVERSATION_STATES_COLORS = {
  [CONVERSATION_STATES.OPENED]: 'var(--vis-pink-50)',
  [CONVERSATION_STATES.SNOOZED]: 'var(--vis-turquoise-50)',
  [CONVERSATION_STATES.CLOSED]: 'var(--vis-slateblue-50)',
};

export enum METRIC_DISPLAY_OVERRIDES {
  WORKFLOW_CONVERSATION_RATING_RATING_INDEX = 'workflow_conversation_rating.rating_index',
  BOT_CONVERSATION_RATING_RATING_INDEX = 'bot_conversation_rating.rating_index',
  CONVERSATION_RATING_RATING_INDEX = 'conversation_rating.rating_index',
  RATING_INDEX = 'rating_index',
  CONVERSATION_STATE = 'conversation_state',
}

export const COLOR_MAPPINGS = {
  [METRIC_DISPLAY_OVERRIDES.WORKFLOW_CONVERSATION_RATING_RATING_INDEX]: CONVERSATION_RATINGS_COLORS,
  [METRIC_DISPLAY_OVERRIDES.BOT_CONVERSATION_RATING_RATING_INDEX]: CONVERSATION_RATINGS_COLORS,
  [METRIC_DISPLAY_OVERRIDES.CONVERSATION_RATING_RATING_INDEX]: CONVERSATION_RATINGS_COLORS,
  [METRIC_DISPLAY_OVERRIDES.RATING_INDEX]: CONVERSATION_RATINGS_COLORS,
  [METRIC_DISPLAY_OVERRIDES.CONVERSATION_STATE]: CONVERSATION_STATES_COLORS,
};

export const REPORTING_CONVERSATION_RATINGS = {
  Unknown: msg`No rating`,
};

export const DEFAULT_HEATMAP_COLORS: [number, string][] = [
  [0, 'var(--vis-blue-70)'],
  [0.14, 'var(--vis-blue-70)'],
  [0.28, 'var(--vis-blue-60)'],
  [0.5, 'var(--vis-blue-50)'],
  [0.68, 'var(--vis-blue-40)'],
  [0.82, 'var(--vis-blue-30)'],
  [1, 'var(--vis-blue-20)'],
];

export const CSAT_COLOR_MAPPINGS: [number, string][] = [
  [0, 'var(--vis-salmon-40)'],
  [0.25, 'var(--vis-yellow-50)'],
  [0.5, 'var(--vis-yellow-70)'],
  [0.75, 'var(--vis-green-60)'],
  [1, 'var(--vis-green-40)'],
];

export const CSAT_METRICS = [
  'conversation_rating.rating_index',
  'workflow_conversation_rating.rating_index',
  'bot_conversation_rating.rating_index',
  'rating_index',
  'conversation_rating.human.csat',
  'conversation_rating.human.csat.first_user_conversation_part_created_at',
  'conversation_rating.workflows.csat',
  'conversation_rating.ai_agent.csat',
  'conversation_rating.any_agent.csat',
];
